// extracted by mini-css-extract-plugin
export default {"sectionHeader":"RecentLoans_sectionHeader__8ERx5","alertSection":"RecentLoans_alertSection__ICEj4","recentLoanCard":"RecentLoans_recentLoanCard__Lj3Z0"};